const mimarProfit = {
    list:{
        filters:{
            fromDatePlaceholder:'From date',
            fromDateLabel:'From date',
            toDatePlaceholder:'To date',
            toDateLabel:'To date',
        }
    },
    expenseTable: {
        headlines: {
            expenseName: "Expense Name",
            expenseDate: "Expense Date",
            expenseAmount: "Expense Amount"
        },
        noDataDescription: "There’s no expenses yet",
        addExpenseButton: "Add Expense",
        addEditExpenseModal: {
            expenseNameEn: {
                label: "Expense Name (En)",
                placeholder: "Enter Expense Name (En)",
            },
            expenseNameAr: {
                label: "Expense Name (Ar)",
                placeholder: "Enter Expense Name (Ar)",
            },
            expenseDate: {
                label: "Date",
                placeholder: "Enter Expense Date",
            },
            title: "Add Expense",
            expenseAmount: {
                label: "Amount",
                placeholder: "Enter Expense Amount",
            },
            addTitle: "Add Expense",
            editTitle: "Edit Expense",
        },
        deleteExpenseModal: {
            title: "Delete Expense",
            deleteConfirmationMsg: "Are you sure you want to delete this expense? This action is permanent and cannot be undone. "
        },
    },
    expenseInfo:
        {
            expenseTitle: "Total VAT",
            expenseInfoText: "The total value-added tax (VAT) amount deducted from Mimar’s gains. This represents all VAT collected from settled transactions.",
            label: "SAR",
        },
    profitCards: {
        netProfit: {
            name: "Net Profit",
            infoText: "The remaining profit after deducting all expenses and VAT from the total settled gains. This reflects Mimar’s actual earnings.",
        },
        settledProfit: {
            name: "Settled Profit", 
            infoText: "Profit from funds that have been fully collected and cleared from VAT%. These amounts are already available in your account.",
        },
        unSettledProfit: {
            name: "Un-Settled Amount",
            infoText: "Profit from funds that are still pending settlement. These will be added to your total profit once the providers’ payments are received."
        },
        expenses: {
            name: "Expenses",
            infoText: "The total operational costs or deductions recorded by Mimar."
        }
    },
}
export default mimarProfit;